// extracted by mini-css-extract-plugin
export default {"info":"InfoUlezPage-module__info-JSeI","content":"InfoUlezPage-module__content-I3ju"};